import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AboutUs = () => {
  return (
    <div className="bg-white text-gray-800">
        <Navbar />
      {/* Hero Section */}
      <section className="bg-blue-50 px-6 py-16 text-center">
        <h2 className="text-sm uppercase tracking-widest text-blue-600 font-medium mb-2">Wanna learn who we are?</h2>
        <h1 className="text-4xl sm:text-5xl font-bold leading-tight mb-4">
          Get a Chance to <br className="hidden sm:block" />
          know About Us and <span className="bg-gradient-to-r from-slate-400 via-zinc-400 to-stone-800 text-transparent bg-clip-text">Relive Our Journey</span>
        </h1>
        <p className="max-w-2xl mx-auto mb-6 text-gray-600">Meet our dynamic team and discover the roadmap to success as we will let you know how we work.</p>
        <button className="bg-white border border-blue-500 text-blue-600 px-6 py-2 rounded-full font-medium hover:bg-blue-100">Let's talk</button>
        <img src="/team-photo.png" alt="Our Team" className="mx-auto mt-10 max-w-xl rounded-lg shadow-md" />
      </section>

      {/* Stats */}
      <section className="py-12 bg-white grid grid-cols-2 md:grid-cols-4 text-center gap-6 max-w-5xl mx-auto">
        <div><h3 className="text-3xl font-bold">1k+</h3><p className="text-sm text-gray-500">Customers<br />33 countries</p></div>
        <div><h3 className="text-2xl font-semibold">#1</h3><p className="text-sm text-gray-500">Global Leader 2025<br />Clutch</p></div>
        <div><h3 className="text-3xl font-bold text-orange-500">4.9★</h3><p className="text-sm text-gray-500">G2</p></div>
        <div><h3 className="text-3xl font-bold text-green-500">4.8★</h3><p className="text-sm text-gray-500">Trustpilot</p></div>
      </section>

      {/* Values & Goal Section */}
      <section className="bg-gray-50 py-16 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10">
          <div>
            <h2 className="text-xl font-semibold mb-4 text-blue-600">About Our Values</h2>
            <p className="mb-6 text-gray-700">We prioritize quality over quantity. Our approach is to concentrate on each client's project with unwavering dedication, ensuring that we deliver exceptional results that exceed expectations.</p>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <h4 className="font-semibold text-sm mb-1">Learning</h4>
                <p className="text-xs text-gray-600">Our team consistently seeks opportunities to expand their knowledge and enhance their skills.</p>
              </div>
              <div>
                <h4 className="font-semibold text-sm mb-1">Team-work</h4>
                <p className="text-xs text-gray-600">Our team members excel in collaboration and are always ready to assist one another.</p>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-4 text-blue-600">Our Goal Statement</h2>
            <p className="mb-4 text-gray-700">At Community Portal, we live by action, progress, and growth. We've already accomplished significant milestones, yet our hunger for more remains unfulfillable.</p>
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <h4 className="font-semibold">Integrity</h4>
                <p className="text-xs text-gray-600">Honesty is our guiding principle, ensuring that we meet and exceed expectations.</p>
              </div>
              <div>
                <h4 className="font-semibold">Commitment</h4>
                <p className="text-xs text-gray-600">Our commitment to our work and clients forms an unbreakable bond.</p>
              </div>
              <div>
                <h4 className="font-semibold">Passion</h4>
                <p className="text-xs text-gray-600">We deliver with relentless passion, on-time delivery, and growth-focused outcomes.</p>
              </div>
            </div>
            <button className="mt-6 bg-white border border-blue-500 text-blue-600 px-5 py-2 rounded-full hover:bg-blue-100">Let's talk</button>
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="text-center py-16">
        <h2 className="text-2xl font-bold mb-4">Come join us in our journey to <span className="text-orange-500">growth</span> and <span className="bg-gradient-to-r from-pink-500 to-purple-500 text-transparent bg-clip-text">betterment</span></h2>
        <div className="flex justify-center space-x-6 mt-6 text-sm font-medium text-gray-600">
          {[2022, 2023, 2024, 2025].map(year => (
            <span key={year} className={year === 2016 ? "text-blue-600 font-bold underline" : ""}>{year}</span>
          ))}
        </div>
      </section>

      {/* Executive Profile */}
      <section className="bg-white px-6 py-16 text-center">
        <h2 className="text-3xl font-bold mb-8">Meet our Inspiring <span className="bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 text-transparent bg-clip-text">Executive</span></h2>
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-6">
          <img src="/ashir.png" alt="Ashirbad Ghosh" className="w-36 h-36 rounded-full object-cover shadow-md" />
          <div className="text-left">
            <h3 className="text-xl font-bold">Ashirbad Ghosh</h3>
            <p className="text-sm text-gray-500 mb-2">Founder of HOA Portal & Community Portal</p>
            <p className="text-sm text-gray-700">
              Ashirbad is the CEO of AMGCorp and has over ten years of experience in desining products. His passion is helping businesses scale using data-driven strategies and make technology more assessable to people.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutUs;
